<section class="ods-modal" [attr.aria-labelledby]="heading ? titleId : null">
  <h2 *ngIf="heading" class="ods-modal__title" [id]="titleId">{{ heading }}</h2>

  <div class="ods-modal__body">
    <ng-content></ng-content>
  </div>

  <div class="ods-modal__actions">
    <ng-content select="[modalActions]"></ng-content>
  </div>
</section>
